import OpenInNewIcon from "@mui/icons-material/OpenInNew"

interface AcademicCalendarLinkProps {
  url?: string | null
  size?: number
}

const AcademicCalendarLink = ({ url, size = 16 }: AcademicCalendarLinkProps) => {
  if (!url) return null

  const href = /^https?:\/\//i.test(url) ? url : `https://${url}`

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      title="Academic Calendar"
      onClick={(e) => e.stopPropagation()}
      className="d-inline-flex align-items-center text-decoration-none text-muted ms-1"
    >
      <OpenInNewIcon sx={{ fontSize: size }} />
    </a>
  )
}

export default AcademicCalendarLink
